module.exports = __webpack_public_path__ + "img/curso_4_texto.98d6ebb5.png";